
  <tds-modal size="sm" closeIconButtonLabel="Close">
    <tds-modal-title>{{ title() }}</tds-modal-title>
    {{  text() }}
    <tds-modal-actions>
      <button tds-button variant="tertiary" (click)="close('actionCanceled')" (keyup)="close('actionCanceled')">{{ closeText() }}</button>
      <button tds-button (click)="close('actionConfirmed')" (keyup)="close('actionConfirmed')">{{ confirmText() }}</button>
    </tds-modal-actions>
  </tds-modal>
